import * as React from 'react';
import { useQuery } from '@apollo/client';

import * as QueryTags from '../../core/gql/queries/tags';

import { TagType } from '../../models/tag';

import OrgTag from './organization-tag';

interface Props {
  orgId: number;
}

const OrgStructure: React.FunctionComponent<Props> = ({ orgId }) => {
  const queryTags = useQuery(QueryTags.QUERY, { variables: { organizationId: orgId } });
  const tags = queryTags.data?.tags;

  return (
    <div>
      <OrgTag orgId={orgId} orgTags={tags} tagTypeName={TagType.AREA_OF_OPERATION} />
      <OrgTag orgId={orgId} orgTags={tags} tagTypeName={TagType.AGE_DIVISION} />
      <OrgTag orgId={orgId} orgTags={tags} tagTypeName={TagType.COMPETITION_GENDER} />
      <OrgTag orgId={orgId} orgTags={tags} tagTypeName={TagType.COMPETITION_LEVEL} />
    </div>
  );
};

export default OrgStructure;
